import AuctionService from '@/services/auction-service.js';
import types from './mutation-types';
import { isCancel, CancelToken } from 'axios';
import { isNil, omit } from 'lodash';

let requestSource = null;

class AuctionItems {

	constructor(commit, auctionId) {
		this.commit = commit;
		this.auctionId = auctionId;
	}

	fetchItems(params) {
		// cancel all current requests
		if (!isNil(requestSource)) {
			requestSource.cancel();
		}

		requestSource = CancelToken.source();

		this.commit(types.FETCH_AUCTION_ITEMS_START);

		const handleSuccess = this.handleSuccess.bind(this);
		const handleError = this.handleError.bind(this);

		if(params.personId) {
			const personId = params.personId;
			params = omit(params, 'personId');

			return AuctionService.getAuctionPersonItems(
				this.auctionId, personId, params, requestSource.token)
				.then(handleSuccess)
				.catch(handleError);
		} else {
			return AuctionService.getAuctionItems(
				this.auctionId, params, requestSource.token)
				.then(handleSuccess)
				.catch(handleError);
		}
	}

	handleSuccess(data) {
		this.commit(types.FETCH_AUCTION_ITEMS, {
			items: data.data,
			meta: {
				currentPage: data.current_page,
				total: data.total,
				perPage: data.per_page,
				totalPages: this.calculateTotalPages(data.per_page, data.total)
			}
		});
	}

	handleError(error) {
		if (!isCancel(error)) {
			throw error;
		}
	}

	calculateTotalPages(perPage, total) {
		return Math.ceil(total / perPage);
	}
}

const actions = {
	getAuction({ commit }, auctionId) {
		return AuctionService.getOne(auctionId).then(auction => {
			commit(types.SET_ACTIVE_AUCTION, auction);
		});
	},
	setActiveAuction({ commit }, auction) {
		commit(types.SET_ACTIVE_AUCTION, auction);
	},
	getAuctions({ commit }) {
		return AuctionService.get().then(auctions => {
			commit(types.GET_AUCTIONS, auctions);
		});
	},
	fetchAuctionItems({ commit }, { auctionId, params }) {
		return new AuctionItems(commit, auctionId).fetchItems(params);
	}
};

export default actions;


// WEBPACK FOOTER //
// ./src/store/modules/auction/actions.js